// extracted by mini-css-extract-plugin
module.exports = {"root":"SummaryCardLayout__root--1Ol9e","image":"SummaryCardLayout__image--1bqnE","main":"SummaryCardLayout__main--2gQAv"};